import React, { useState, useEffect, useRef } from "react";

import { BackCaretIcon } from "./icons";
import CustomAccordion from "./customAccordion";

// TODO: EXTEND THIS TO BE CMSABLE. AWAITING DOWN TIME IN TICKETS AND APPROVAL TO DO.
const EmbAppliqueGuide = (props) => {
  const fonts = [
    {
      name: "Perry",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Perry_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Perry_480x480.png?v=1721651155",
      description:
        "The perfect traditional monogram! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Ardsley",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Adrsley_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Adrsley_480x480.png?v=1721651154",
      description:
        "Available for 1 or 3 letters.  Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Hudson",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Hudson_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Hudson_480x480.png?v=1721651155",
      description:
        "Simple but charming! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Prince",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/princeton_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Prince_480x480.png?v=1721651155",
      description:
        "Our most modern embroidery style with same-size lettering. Available for 1-4 letters.  Enter First Initial, Middle Initial, Last Initial.",
    },
    {
      name: "Crosby",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Crosby_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Crosby_480x480.png?v=1721651155",
      description:
        "Available for 3 letters. Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Jones",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ACBjones.svg?v=1723732712",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Jones_480x480.png?v=1721651155",
      description:
        "Available for 3 letters.  Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Mercer",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Mercer_480x480.png?v=1721651154",
      description:
        "Available for 1 letter.  Enter First Initial or Last Initial.",
    },
    ,
    {
      name: "River",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/River_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/River_480x480.png?v=1721651155",
      description:
        "A Weezie classic and the easiest way to say it all. Available for 1-11 characters.",
    },
    {
      name: "Waverly",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Waverly_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/waverly_480x480.png?v=1721651155",
      description:
        "The perfect script with a playful twist.  A favorite for babies, beach and beyond! Available for 1-11 characters.",
    },
    {
      name: "Tybee",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Tybee_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Tybee_480x480.png?v=1721651155",
      description:
        "Available for 1-11 characters. Enter First Initial, Middle Initial, Last Initial.",
    },
    {
      name: "Sullivan",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Sullivan_480x480.svg?v=1721643849",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Sullivan_480x480.png?v=1721651154",
      description:
        "Available for 1-11 characters. Enter First Initial, Middle Initial, Last Initial.",
    },
  ];
  const icons = [
    {
      name: "Duck",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_480x480.svg?v=1722249909",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/BurpCloth_Ducky_1_430x.png?v=1722253648",
      description: "A playful rubber duck for bath time fun.",
    },
    {
      name: "Boat",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1791_430x.svg?v=1722249905#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232471_1_430x.png?v=1722250841",
      description: "A nod to nautical.",
    },
    {
      name: "Bow",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Vector_480x480.svg?v=1722249914",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232475_1_430x.png?v=1722250841",
      description:
        "Inspired by towels our Creative Director Liz had as a little girl.",
    },
    {
      name: "2 Hearts",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1_430x.svg?v=1722249918#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Heart-MUT-PDP-Coral_1_430x.png?v=1722250842",
      description: "Heart eyes over Weezie? Us too! ",
    },
    {
      name: "3 Hearts",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_2_430x.svg?v=1722249922#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232483_1_1_430x.png?v=1722250842",
      description: "Show your love with 3 sweet hearts.",
    },
    {
      name: "Eyelids",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_4_430x.svg?v=1722250556",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232484_1_1_430x.png?v=1722250842",
      description: "The icon that started it all.",
    },
    {
      name: "Rackets",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/rackets_430x.svg?v=1722249930#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1466_430x.png?v=1722250841",
      description: "Serve up a perfect gift for tennis lovers.",
    },
    {
      name: "Clubs",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/clubs.svg?v=1723057834",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1456_430x.png?v=1722250841",
      description: "Towel time takes to the links!",
    },
    {
      name: "Paddles",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/m5YsMK_430x.svg?v=1722249947#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Studio_-_914232474_1_430x.png?v=1722250841",
      description: "Pickle paddle perfection!",
    },
    {
      name: "Eggs",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/eggs-icon.svg?v=1726260151",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/eggs-iconimg.jpg?v=1726589439",
      description: "Celebrate spring with colorful, decorated eggs.",
    },
    {
      name: "Fireworks",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/fireworks-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/fireworks-iconimg.jpg?v=1726589439",
      description:
        "Spark joy with fireworks – perfect for summer's celebratory moments.",
    },
    {
      name: "Shell",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/shells-icon.png?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/shell-iconimg.jpg?v=1726589439",
      description: "A coastal classic.",
    },
    {
      name: "Palm",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/palmtree-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/palm-iconimg.jpg?v=1726589439",
      description: "Add a tropical twist with a breezy palm tree.",
    },
    {
      name: "Pumpkins",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/pumpkins-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/pumpkins-iconimg.jpg?v=1726589439",
      description: "A festive addition to your fall lineup.",
    },
    {
      name: "Flutes",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/flutes-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/flutes-iconimg.jpg?v=1726589439",
      description: "Cheers to good times with clinking champagne flutes.",
    },
    {
      name: "Garland",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/garland-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/garland-iconimg.jpg?v=1726589439",
      description: "Deck the halls with festive garland.",
    },
    {
      name: "Wreath",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wreath-icon.svg?v=1726260525",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wreath-iconimg.jpg?v=1726589439",
      description: "A classic holiday wreath for a touch of winter festivity.",
    },
  ];
  const applique = [
    {
      name: "Forsyth",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/forsyth-ex_430x.png?v=1722886338#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Weezie_Lifestyle-_62720241580_1_430x.png?v=1722340691",
      description:
        "Our beloved Perry font, now in applique! Available for 1-3 letters. Enter First Initial, Last Initial, Middle Initial.",
    },
    {
      name: "Ponce",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_1_430x.svg?v=1722249970#",
      hoverUrl:
        "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Applique_ScallopBathTowel_1_1_430x.png?v=1722340675",
      description:
        "A charming and timeless choice for your initial. Available for 1 letter. Enter First Initial or Last Initial.",
    },
  ];
  const personaliseOption1 = [
    {
      title: "Single Initial",
      description: "First or Last",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_28a95c68-b7f7-481c-8da6-d9230b450d39_480x480.svg?v=1721991748",
    },
    {
      title: "Three Initials",
      description: "First, Middle, Last",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1849_1d814983-07d7-4284-9f3a-13ce0a98e0d6_480x480.png?v=1721991749",
    },
    {
      title: "Three Initials",
      description: "First, Last, Middle",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/carter-grace-bates.png?v=1722882774",
    },
  ];
  const HQPicks = [
    {
      title: "Perry or Ardsley",
      description: "If you prefer a more traditional look:",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/hq-perry2.jpg?v=1723734003",
    },
    {
      title: "Prince, Hudson or Crosby",
      description: "If you like something that is more modern:",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1853_480x480.png?v=1722240707",
    },
    {
      title: "Waverly, Sullivan or River",
      description: "If you want to spell it out:",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Group_1854_480x480.png?v=1722240707",
    },
    {
      title: "Perry or Prince",
      description: "If you prefer two initials to three:",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/hq-perry.jpg?v=1723733343",
    },
    {
      title: "Forsyth or Ponce",
      description: "If you prefer designer approved applique:",
      url: "https://cdn.shopify.com/s/files/1/0019/0352/5941/files/applique-ponce.jpg?v=1722886069",
    },
  ];
  const accordionData1 = [
    {
      title: "What are my options?",
      content:
        "Piping, embroidery styles, and thread - oh my! We have multiple piping colors, embroidery styles, Applique fabrics, and thread colors for you to choose from. We provide the canvas, you make it custom!",
    },
    {
      title: "What is your most popular style?",
      content:
        "Our most popular fonts are Perry for monograms and River for script words.",
    },
    {
      title: "What's the difference between embroidery and Applique?",
      content:
        "Embroidery uses thread to stitch directly onto the fabric (in this case, terry!), while Applique involves cutting an additional piece of fabric with laser-cut precision and placing it directly on top of the terry. It's then secured with stitches around the perimeter, adding an extra level of design and dimension to your Weezie.",
    },
  ];
  const accordionData2 = [
    {
      title: "Where do I put my initials if I’m monogramming?",
      content:
        "Up to you. But in general, if each letter is the same size, put your initials in the order of first, middle, last name. If the middle letter is bigger, do first, last, middle. Our embroidery guide gives you the 411 on each embroidery option. It’s our secret weapon and now it’s yours too.",
    },
    {
      title: "What is the most traditional monogram option?",
      content:
        "If we're following our grandmother's guidance, she'd suggest a three-letter monogram with a large center initial. We say you do you! Weezie offers multiple three-letter options in this style including Perry, Crosby, and Ardsley.",
    },
    {
      title: "What is the most modern monogram option?",
      content:
        "Prince is one of our most modern monogram styles with all letters being the same size, and River is a fun way to write more than just initials!",
    },
    {
      title: "I have a four-initial name, what should I do?",
      content:
        "Embroider all four! Our Prince, River, Waverly, Tybee, and Sullivan fonts allow for 4-letter embroidery.",
    },
    {
      title: "Which embroidery fonts are good for boys and men?",
      content:
        "It’s up to personal preference, but we recommend Hudson for monograms and Sullivan for names or words.",
    },
  ];
  const accordionData3 = [
    {
      title: "Can I split embroidery between pairs and bundles?",
      content: `
        Unfortunately, we aren't able to split embroidery within a bundle. 
        The discounted price reflects the efficiencies offered to us by having identical embroidery across each towel. 
        If you'd like to order different embroidery styles or only certain towels embroidered within the set, your best bet is to order a la carte!
      `,
    },
    {
      title: "What embroidery colors are exact matches to the pipings?",
      content: `
        Most of our embroidery colors are a perfect match to the corresponding piping, except Pink, Green, Navy, and Sand. 
        While the thread colors for these aren't an exact match, they're as close as we're able to source from our manufacturer, 
        and most people don't notice the difference! If having an exact match is super important to you, 
        we recommend going with one of the following colors: White, French Blue, Light Blue, Grey, Coral, or Black.
      `,
    },
    {
      title: "Help! How do I decide?",
      content: `
        This is a great problem to have! We know one of the hardest parts is deciding on a piping color and thread color, 
        which is why we designed our embroidery preview! Our embroidery preview will help you visualize your towels- making the decision that much easier.
      `,
    },
    {
      title: "Need some one-on-one help?",
      content: `
        Need some one on one help?  Email us at holler@weezietowels.com
      `,
    },
  ];

  const [visiblePopup, setVisiblePopup] = useState(null);
  const [isFontOpen, setIsFontOpen] = useState(false);
  const [isIconsOpen, setIsIconsOpen] = useState(false);
  const [isAppliqueOpen, setIsAppliqueOpen] = useState(false);
  const [openIndex1, setOpenIndex1] = useState(null);
  const [openIndex2, setOpenIndex2] = useState(null);
  const [openIndex3, setOpenIndex3] = useState(null);
  const [hasEmbroidery, setHasEmbroidery] = useState(false);

  const toggleFontAccordion = () => {
    if (isFontOpen) {
      setVisiblePopup(null);
    }
    setIsFontOpen(!isFontOpen);
  };
  const toggleIconAccordion = () => {
    if (isIconsOpen) {
      setVisiblePopup(null);
    }
    setIsIconsOpen(!isIconsOpen);
  };

  const toggleAplliqueAccordion = () => {
    if (isAppliqueOpen) {
      setIsAppliqueOpen(null);
    }
    setIsAppliqueOpen(!isAppliqueOpen);
  };
  const toggleCustomOptionAccordion1 = (index) => {
    setOpenIndex1(openIndex1 === index ? null : index);
  };
  const toggleCustomOptionAccordion2 = (index) => {
    setOpenIndex2(openIndex2 === index ? null : index);
  };
  const toggleCustomOptionAccordion3 = (index) => {
    setOpenIndex3(openIndex3 === index ? null : index);
  };

  const handleWrapClick = (name) => {
    setCurrentFontName(name);
    setVisiblePopup((prevFont) => (prevFont === name ? null : name));
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
    setVisiblePopup(null);
  };
  const [currentFontName, setCurrentFontName] = useState(null);
  const accordionRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (accordionRef.current) {
        const clickedFontName = event.target
          .closest(".pop")
          ?.querySelector("h3.text")?.textContent;

        if (clickedFontName !== currentFontName) {
          setVisiblePopup(null);
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [accordionRef, currentFontName]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('embvariant') && queryParams.get('embvariant') !== '') {
      setHasEmbroidery(true);
    }
  }, []);
  return (
    <div className={hasEmbroidery?"embroidery__guide": "embroidery__guide--applique"}>
      {/* Uncomment this button if needed */}
      <button
        onClick={() => props.toggle(false)}
        className="embroidery__guide__close type type--medium"
      >
        <BackCaretIcon />
        Back to Personalize
      </button>
        <div className="emb-guide-container">
          <div className="emb-guide-hero">
            <div className="emb-guide-hero__title">
              <img
                src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/camel-new.svg?v=1726145120"
                alt="Weezie Camel"
                className=""
              />
              <h1>The Weezie Embroidery Guide</h1>
            </div>

            {/* <div className="email-box row center-xs center-md center-lg">
              <div className="col-xs-12 col-md-6 col-lg-5">
                <div className="box">
                  <p>
                    <strong>Need some one on one help?</strong>
                    <br />
                    Email us at{" "}
                    <a href="mailto:holler@weezietowels.com">
                      holler@weezietowels.com
                    </a>
                  </p>
                </div>
              </div>
            </div> */}
          </div>

          <div className="emb-how-to">
            <div className="emb-how-to__container">
              <p className="sect-header">Design a towel you love</p>
              <h2>How to customize</h2>

              <div className="steps-container">
                <div className="step-block">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step1-new.png?v=1723658755"
                    alt="Step 1"
                  />
                  <p>Select type of customization</p>
                </div>
                <div className="step-block">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step2-new_9216135e-75f5-4ba3-afbf-4314a0d8ea7e.png?v=1726086311"
                    alt="Step 2"
                  />
                  <p>Choose style & enter text</p>
                </div>
                <div className="step-block">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step3-new2.png?v=1723741988"
                    alt="Step 3"
                  />
                  <p>Pick a thread color</p>
                </div>
                <div className="step-block">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/step4-new_3c3f3f33-04de-4f42-b150-36be9f485e63.png?v=1726086310"
                    alt="Step 4"
                  />
                  <p>Add to cart!</p>
                </div>
              </div>
            </div>
          </div>

          <div className="font-options">
            <p className="sect-header">Endless options made Weezie</p>
            <div className="emb-fonts">
              <CustomAccordion
                title="Meet Our Embroidery Styles"
                isOpen={isFontOpen}
                toggleAccordion={toggleFontAccordion}
                subtitle="We stitch your design directly onto our plush terry, using high-quality thread to create a beautifully detailed and lasting finish. It's a timeless way to make your essentials uniquely yours."
              >
                <div
                  className={`emb-fonts__container ${
                    isFontOpen ? "emb-fonts__container--open" : ""
                  } `}
                  ref={accordionRef}
                >
                  {fonts.map((font) => (
                    <div
                      className="emb-fonts__container__item"
                      key={font.name}
                      onClick={() => handleWrapClick(font.name)}
                    >
                      <div className="emb-fonts__container__wrap">
                        <img src={font.url} alt={font.name} />
                        <p>{font.name}</p>
                      </div>
                      <div
                        className={`pop-wrap ${
                          visiblePopup === font.name
                            ? "pop-wrap--open"
                            : "pop-wrap--hidden"
                        }`}
                        onClick={() => handleWrapClick(font.name)}
                      >
                        <div className="pop">
                          <div className="close-icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={handleCloseClick}
                            >
                              <g id="Group 1829">
                                <g id="Group 1807">
                                  <path
                                    id="Vector"
                                    d="M1 1L21 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                  <path
                                    id="Vector_2"
                                    d="M21 1L1 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <img
                            className="inner-image"
                            src={font.hoverUrl}
                            alt={`${font.name} Hover`}
                          />
                          <h3 className="text">{font.name}</h3>
                          <p>{font.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CustomAccordion>
              <CustomAccordion
                title="Meet our Applique Styles"
                isOpen={isAppliqueOpen}
                toggleAccordion={toggleAplliqueAccordion}
                subtitle="We use a precision-laser to cut a piece of fabric, place it on top of the terry, and stitch around the edges. The result is elevated, design-forward, and functional."
              >
                <div
                  className={`emb-fonts__container ${
                    isAppliqueOpen ? "emb-fonts__container--open" : ""
                  } `}
                  ref={accordionRef}
                >
                  {applique.map((applique) => (
                    <div
                      className="emb-fonts__container__item"
                      key={applique.name}
                      onClick={() => handleWrapClick(applique.name)}
                    >
                      <div className="emb-fonts__container__wrap">
                        <img src={applique.url} alt={applique.name} />
                        <p>{applique.name}</p>
                      </div>
                      <div
                        className={`pop-wrap ${
                          visiblePopup === applique.name
                            ? "pop-wrap--open"
                            : "pop-wrap--hidden"
                        }`}
                        onClick={() => handleWrapClick(applique.name)}
                      >
                        <div className="pop">
                          <div className="close-icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={handleCloseClick}
                            >
                              <g id="Group 1829">
                                <g id="Group 1807">
                                  <path
                                    id="Vector"
                                    d="M1 1L21 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                  <path
                                    id="Vector_2"
                                    d="M21 1L1 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <img
                            className="inner-image"
                            src={applique.hoverUrl}
                            alt={`${applique.name} Hover`}
                          />
                          <h3 className="text">{applique.name}</h3>
                          <p>{applique.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CustomAccordion>
              <CustomAccordion
                title="Meet our Icons"
                isOpen={isIconsOpen}
                toggleAccordion={toggleIconAccordion}
                subtitle="Add a special touch with our embroidered icons. Crafted with high-quality thread and stitched onto plush terry, icons are perfect for a festive or personal detail.  Icons subject to seasonal availability."
              >
                <div
                  className={`emb-fonts__container ${
                    isIconsOpen ? "emb-fonts__container--open" : ""
                  } `}
                  ref={accordionRef}
                >
                  {icons.map((icons) => (
                    <div
                      className="emb-fonts__container__item"
                      key={icons.name}
                      onClick={() => handleWrapClick(icons.name)}
                    >
                      <div className="emb-fonts__container__wrap">
                        <img src={icons.url} alt={icons.name} />
                        <p>{icons.name}</p>
                      </div>
                      <div
                        className={`pop-wrap ${
                          visiblePopup === icons.name
                            ? "pop-wrap--open"
                            : "pop-wrap--hidden"
                        }`}
                        onClick={() => handleWrapClick(icons.name)}
                      >
                        <div className="pop">
                          <div className="close-icon">
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={handleCloseClick}
                            >
                              <g id="Group 1829">
                                <g id="Group 1807">
                                  <path
                                    id="Vector"
                                    d="M1 1L21 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                  <path
                                    id="Vector_2"
                                    d="M21 1L1 21"
                                    stroke="#4187C7"
                                    strokeWidth="2"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                  />
                                </g>
                              </g>
                            </svg>
                          </div>
                          <img
                            className="inner-image"
                            src={icons.hoverUrl}
                            alt={`${icons.name} Hover`}
                          />
                          <h3 className="text">{icons.name}</h3>
                          <p>{icons.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CustomAccordion>
            </div>
          </div>

          {/* Uncomment this block if needed */}
          <div className="personalise">
            <p className="sect-header">Monogram Guide</p>
            <h2>Personalizing for one?</h2>
            <div className="personalise__content">
              <p className="underline">Example</p>
              <h2>Carter Grace Bates</h2>
              <div className="personalise__wrap">
                {personaliseOption1?.map((option) => {
                  return (
                    <div className="personalise__item">
                      <img src={option.url} alt={option.title} />
                      <div>
                        <p className="underline">{option.title}</p>
                        <p>{option.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <h2>Personalizing for two?</h2>
            <div className="personalise__content">
              <p className="underline">Example</p>
              <h2>Lila & Oliver Bennett</h2>
              <p>a couple with the same last names</p>
              <div className="personalise__wrap">
                <div className="personalise__item">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/Layer_1_28a95c68-b7f7-481c-8da6-d9230b450d39_430x.svg?v=1721991748#"
                    alt="font"
                  />
                  <div>
                    <p className="underline">Single Initial</p>
                    <p>First or Last</p>
                  </div>
                </div>
                <div className="personalise__item">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1504_430x.png?v=1722338621"
                    alt="font"
                  />
                  <div>
                    <p className="underline">Three Initials</p>
                    <p>First, Last, First</p>
                  </div>
                </div>
              </div>
              <div className="content-line"></div>
              <p className="underline">Example</p>
              <h2>
                Carter Lee Smith &<span>Alex Fitzgerald</span>
              </h2>
              <p>a couple with different last names</p>
              <div className="personalise__wrap">
                <div className="personalise__item">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/image_1470_430x.png?v=1722322051"
                    alt="font"
                  />
                  <div>
                    <p className="underline">Three Initials</p>
                    <p>First, Last, Middle of one partner</p>
                  </div>
                </div>
                <div className="personalise__item">
                  <img
                    src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/csaf2.svg?v=1726238571"
                    alt="font"
                  />
                  <div>
                    <p className="underline">Four initials</p>
                    <p>First and Last in any order</p>
                  </div>
                </div>
              </div>
            </div>
            <h2>Words & Numbers</h2>
            <div className="personalise__number">
              <p>
                You do you. Embroider something cheeky or cheerful. The options
                are endless and up to you - we just make it Weezie.
              </p>
              <p className="example">Example</p>
              <div className="number__wrap">
                <div className="number__item">
                  <img src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/wordcloudv5.svg?v=1728068176"></img>
                </div>
                {/* <div className="number__item">
                  <img src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/smithguest.svg?v=1723051834"></img>
                </div>
                <div className="number__item">
                  <img src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/BEACHHOUSE.svg?v=1723055605"></img>
                </div>
                <div className="number__item">
                  <img src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/poolLila.svg?v=1723055606"></img>
                </div> */}
              </div>
              {/* <p>
                There is a limit of 12 characters on our script to keep things
                looking pretty
              </p> */}
            </div>
            <div className="email-box row center-xs center-md center-lg">
              <div className="col-xs-12 col-md-10 col-lg-10">
                <div className="box">
                  <p>
                    <strong>Need some one on one help?</strong>
                    <br />
                    Email us at{" "}
                    <a href="mailto:holler@weezietowels.com">
                      holler@weezietowels.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="HqPicks">
            <h2>HQ Advice</h2>
            <div className="HQPicks__wrap">
              {HQPicks.map((pick, index) => (
                <div
                  className={`HQPicks__container ${
                    index % 2 === 0 ? "normal" : "reverse"
                  }`}
                  key={index}
                >
                  <div className="HQPicks__image">
                    <img src={pick.url} alt={pick.title} />
                  </div>
                  <div className="HQPicks__description">
                    <p>{pick.description}</p>
                    <h3>{pick.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="faq-custom__wrapper">
            <div className="faq-custom">
              <div>
                <p className="sect-header">FAQs</p>
              </div>
              <h3> Customization Options</h3>
              <ul class="faq-custom__content">
                {accordionData1.map((item, index) => (
                  <li
                    className={`accordion ${
                      openIndex1 === index ? "open" : ""
                    }`}
                    key={index}
                  >
                    <button
                      className="accordion__title type faq-custom__container"
                      onClick={() => toggleCustomOptionAccordion1(index)}
                    >
                      {item.title}
                    </button>
                    <div className="accordion__content type type--medium">
                      <div className="faq-custom__container">
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <h3>Monogram Style</h3>
              <ul class="faq-custom__content">
                {accordionData2.map((item, index) => (
                  <li
                    className={`accordion ${
                      openIndex2 === index ? "open" : ""
                    }`}
                    key={index}
                  >
                    <button
                      className="accordion__title type faq-custom__container"
                      onClick={() => toggleCustomOptionAccordion2(index)}
                    >
                      {item.title}
                    </button>
                    <div className="accordion__content type type--medium">
                      <div className="faq-custom__container">
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <h3>Product Information</h3>
              <ul class="faq-custom__content">
                {accordionData3.map((item, index) => (
                  <li
                    className={`accordion ${
                      openIndex3 === index ? "open" : ""
                    }`}
                    key={index}
                  >
                    <button
                      className="accordion__title type faq-custom__container"
                      onClick={() => toggleCustomOptionAccordion3(index)}
                    >
                      {item.title}
                    </button>
                    <div className="accordion__content type type--medium">
                      <div className="faq-custom__container">
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* <div className="footer">
            <div className="footer-img">
              <img
                className=""
                src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/footer-bg.jpg?v=1723057454"
                alt="Weezie Towels on a bath tub"
              />
            </div>
            <div className="footer__email-box row center-xs center-md center-lg">
              <div className="box">
                <p>
                  Email us at{" "}
                  <a href="mailto:holler@weezietowels.com">
                    holler@weezietowels.com
                  </a>
                </p>
              </div>
            </div>
          </div> */}
        </div>
    </div>
  );
};

export default EmbAppliqueGuide;
